import cx from 'classnames';
import React from 'react';
import styles, { keyframes } from 'styled-components';

import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps, AnimatedTransformProps } from './interfaces';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styles(Elements.Svg)<AnimatedTransformProps>`
  animation: ${rotate} ${props => props.duration ?? '1s'} linear infinite;
`;

const Spinner: React.FC<IconProps> = ({
  className = '',
  width = 105,
  height = 105,
  viewBox = '0 0 105 105',
  duration = '1s',
  d = 'M45.5,1.42108547e-14 C20.3710439,1.42108547e-14 -3.55271368e-15,20.3710439 -3.55271368e-15,45.5',
  pathStroke = '#E3710A',
  circleStroke = '#E8E9E9',
  cssHelper = Styling.transitionVisible,
  focusable
}) => {
  return (
    <SpinnerWrapper
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      duration={duration}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G stroke='none' strokeWidth='1' fill='none' fill-rule='evenodd'>
        <Elements.G transform='translate(-42.000000, -1667.000000)'>
          <Elements.G transform='translate(40.000000, 1579.000000)'>
            <Elements.G transform='translate(2.000000, 88.000000)'>
              <Elements.G transform='translate(7.000000, 7.000000)'>
                <Elements.Circle
                  stroke={circleStroke}
                  strokeWidth='14'
                  cx='45.5'
                  cy='45.5'
                  r='45.5'
                />
                <Elements.Path
                  d={d}
                  stroke={pathStroke}
                  strokeWidth='14'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <Elements.AnimatedTransform />
              </Elements.G>
            </Elements.G>
          </Elements.G>
        </Elements.G>
      </Elements.G>
    </SpinnerWrapper>
  );
};

export default Spinner;
